var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadnow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_620_1583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_620_1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 16.6663C2.87484 16.6663 2.48248 16.5031 2.15609 16.1768C1.8297 15.8504 1.6665 15.458 1.6665 14.9997V4.99967C1.6665 4.54134 1.8297 4.14898 2.15609 3.82259C2.48248 3.4962 2.87484 3.33301 3.33317 3.33301H16.6665C17.1248 3.33301 17.5172 3.4962 17.8436 3.82259C18.17 4.14898 18.3332 4.54134 18.3332 4.99967V14.9997C18.3332 15.458 18.17 15.8504 17.8436 16.1768C17.5172 16.5031 17.1248 16.6663 16.6665 16.6663H3.33317ZM3.33317 14.9997H9.1665V4.99967H3.33317V14.9997ZM10.8332 14.9997H16.6665V4.99967H10.8332V14.9997ZM11.6665 12.4997H15.8332V11.2497H11.6665V12.4997ZM11.6665 10.4163H15.8332V9.16634H11.6665V10.4163ZM11.6665 8.33301H15.8332V7.08301H11.6665V8.33301Z",
    fill: "#051A16"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadnow);
export default __webpack_public_path__ + "static/media/readnow.853d669a89574cc328484f4d6326c160.svg";
export { ForwardRef as ReactComponent };